const config = {
  API_BASE_URL: process.env.REACT_APP_API_URL ?? "",
};

console.log("NODE_ENV:", process.env.NODE_ENV);
console.log("API_BASE_URL:", config.API_BASE_URL || "(relative /api)");

export default config;
